require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-new-vice-president-of-human-resources-operations-and-service.json") })
        }
      }, "path---es-articles-new-vice-president-of-human-resources-operations-and-service");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-new-vice-president-of-human-resources-operations-and-service!./.cache/json/es-articles-new-vice-president-of-human-resources-operations-and-service.json
// module id = 2222
// module chunks = 231608221292675